import { render, staticRenderFns } from "./Lojas.vue?vue&type=template&id=04acdb29&"
import script from "./Lojas.vue?vue&type=script&lang=js&"
export * from "./Lojas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports